import React from 'react';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { formatNumber } from '../../../../utils/utils';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import circleGreen from '../../../../assets/images/icons/circle-color-green.svg';
import circleRed from '../../../../assets/images/icons/circle-color-red.svg';

interface WarehouseOrderItemRow {
    id?: number;
    product_name?: string;
    service_name?: string;
    depot_name?: string;
    quantity?: string;
    quantity_unit?: string;
    status?: string;
    status_selected?: any;
    total_guide?: number | null;
}

interface Props {
    warehouseOrderItem: WarehouseOrderItemRow | null | undefined;
    totalGuide?: number | null;
    onAdd?: (id: number) => void;
}

const WarehouseSubOrderItemsDataTable = ({ warehouseOrderItem, totalGuide, onAdd }: Props) => {
    const columns = [
        {
            name: 'Producto',
            selector: (row: any) => row?.product_name,
            sortable: false,
        },
        {
            name: 'Servicio',
            selector: (row: any) => row?.service_name,
            sortable: false,
        },
        {
            name: 'Almacén',
            selector: (row: any) => row?.depot_name,
            sortable: false,
        },
        {
            name: 'Cantidad del pedido',
            selector: (row: any) => row?.quantity,
            sortable: false,
            cell: (row: any) => {
                const qty = parseFloat(row.quantity ?? '0');
                return `${formatNumber(qty)} ${row.quantity_unit ?? ''}`;
            }
        },
        {
            name: 'Cantidad despachada',
            selector: (row: any) => row?.total_guide,
            sortable: false,
            cell: (row: any) => {
                if (row.total_guide == null) return '-';
                const match = row.total_guide === parseFloat(row.quantity ?? '0');
                return (
                    <span>
                        <img
                            src={match ? circleGreen : circleRed}
                            alt=""
                            style={{ width: '20px', height: '20px', marginRight: '3px', marginBottom: '3px' }}
                        />
                        {formatNumber(row.total_guide)} {row.quantity_unit ?? ''}
                    </span>
                );
            }
        },
        {
            name: 'Acciones',
            sortable: false,
            cell: (row: any) => (
                <div>
                    {onAdd && (
                        <ButtonTableAction
                            callbackFunction={() => onAdd(row.id ?? -1)}
                            classIcon={'mdi mdi-plus'}
                            colorIcon={'text-success'}
                            errorMessage={'No se puede agregar posición.'}
                            title={'Agregar posición de despacho'}
                        />
                    )}
                </div>
            )
        },
    ];

    const data = warehouseOrderItem
        ? [{ ...warehouseOrderItem, total_guide: totalGuide }]
        : [];

    return (
        <DefaultDataTable
            data={data}
            columns={columns}
            paginationTotalRows={data.length}
            filter={undefined}
            setFilter={(_filter: any) => { /* sin paginación */ }}
            pagination={false}
        />
    );
};

export default WarehouseSubOrderItemsDataTable;
